// removed by extract-text-webpack-plugin
module.exports = {"ipad-portrait":"768px","mobile":"480px","background-grey":"#f6f6f6","wrapper":"_2h5n9p97DdYhcVmwaJxocd","left":"wrh-sBuHHLJ9VwG6NArC-","pageBg":"_1i614bh0SCuWFblawyHWT4"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Banner/OthersBanner/CarouselBanner/CarouselBanner.css
// module id = 1414
// module chunks = 0